import React from 'react';
import SliderQuestion from './SliderQuestion';
import CheckboxQuestion from './CheckboxQuestion';
import RadioButtonQuestion from './RadioButtonQuestion';
import { Box, ToggleButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { setPreviousAnswers, setQuestionnaire } from '../../redux/slices/onboarding/onboardingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { uploadTraitStrengthMapping } from '../../redux/slices/onboarding/onboardingThunk';

const Question = ({ question, pInd, qInd, next }) => {
    const dispatch = useDispatch();
    const onMobile = !useMediaQuery('(min-width:600px)');
    const answers = question.AnswerChoices;
    const theme = useTheme();

    const { questionnaire, previousAnswers } = useSelector(state => state.onboarding);

    const makeTraitCards = (answer) => {
        //Render based on answer type
        switch(answer.type) {
            case("EXPANDING_SLIDER"):
            return (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <SliderQuestion 
                        pInd={pInd} 
                        qInd={qInd}
                        answer={answer}
                        format={answer.type} 
                    />
                </Box> 
            )
            case("SLIDER"):
                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <SliderQuestion 
                            pInd={pInd} 
                            qInd={qInd}
                            answer={answer}
                            format={answer.type} 
                        />
                    </Box> 
                )
            case ("MULTISELECT"):
                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <CheckboxQuestion 
                            pInd={pInd} 
                            qInd={qInd}
                            answer={answer}
                        />
                    </Box>
                )
            default:
                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <RadioButtonQuestion 
                            pInd={pInd} 
                            qInd={qInd}
                            answer={answer}
                        />
                    </Box>
                )
        }
    }

    const handleDecline = async(e) => {
        //should clear any selections made for the current question
        e.preventDefault();
        const tempPreviousAnswers = JSON.parse(JSON.stringify(previousAnswers));
        const tempQuestionnaire = JSON.parse(JSON.stringify(questionnaire));

        tempQuestionnaire[pInd].SurveyQuestions[qInd].AnswerChoices.forEach((tempAnswer) => {
            tempAnswer.selected = null;
            tempPreviousAnswers[tempAnswer.id] = null;
        });
        
        dispatch(setPreviousAnswers(tempPreviousAnswers));
        dispatch(setQuestionnaire(tempQuestionnaire));
        dispatch(uploadTraitStrengthMapping({ previousAnswers: tempPreviousAnswers, questionnaire: tempQuestionnaire, pageIndex: pInd }));
        next(e);
    }

    return (
        question &&
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box>
                    <Typography
                        sx={{
                            padding: "2rem 2rem 0 2rem",
                            fontSize: !onMobile ? "1.8em" : "1.75em",
                            fontWeight: "bold",
                            textAlign: "center",
                            width: "100%",
                        }}
                    >
                        {question.text}
                    </Typography>
                </Box>
                <Box sx={answers?.length > 6 ? {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        height: "100%",
                        padding: "2rem",
                    } : {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "2rem"
                }}>
                    {answers.map(answer => {
                        return ( makeTraitCards(answer) )
                    })}
                    <ToggleButton
                        pInd={pInd} 
                        selected={false}
                        onClick={async (e) => await handleDecline(e)}
                        sx={{
                            margin: "0.5rem",
                            backgroundColor: theme.palette.caralystRed.dark,
                            width: '40vw',
                            minWidth: "18rem",
                            maxWidth: "25rem",
                            color: "white",
                            transition: "background-color 0.15s ease-in-out",
                            textTransform: "none",
                            fontSize: "1.2em",
                            '&:hover': {
                                backgroundColor: theme.palette.caralystRed.main,
                                color: "white",
                            },
                            '&.Mui-selected': {
                                backgroundColor: theme.palette.caralystRed.main,
                                color: "white",
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: theme.palette.caralystRed.main,
                                color: "white",
                            }
                        }}
                    >
                        Decline To Answer
                    </ToggleButton>
                </Box>
            </Box>
    )
}

export default Question;